export const errors = {
  required: 'จำเป็นต้องกรอกข้อมูลในฟิลด์นี้',
  emailInvalid: 'อีเมลไม่ถูกต้อง',
  passwordTooShort: 'รหัสผ่านจะต้องมีอย่างน้อย 8 ตัวอักษร',
  passwordInvalid:
    'รหัสผ่านจะต้องประกอบด้วย ตัวเล็ก, ตัวใหญ่, ตัวเลข และตัวอักษรพิเศษ',
  passwordDoNotMatch: 'รหัสผ่านไม่เหมือนกัน',
}
